<template>
  <div class="para" style="margin-top: 0">
    <!--
              ****  メッセージ表示領域 **** -->
    <p class="errMsg" id="outMessageArea"></p>
    <!--                          -->
    <div class="frm-item grow left">
      機能利用権限の設定を行います。
      <p class="sup-explanation">税理士事務所の利用者のみ設定可能です。</p>
    </div>
    <!-- <div class="frm-row">
      <div class="frm-item grow left">
        <p class="errMsg title-ico ico-warning" v-show="errors.length > 0">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
      </div>
    </div> -->
    <!-- ******************************************************************
            *  フィルタ条件                                                  *
          ******************************************************************-->
    <div class="criteria">
      <!-- ******************************************************************
                   *  一覧検索                                                      *
                   ****************************************************************** -->
      <div class="frm-row">
        <div class="frm-item">
          <div
            class="frm-search frm-size-xl"
            :class="searchKey ? 'setvalue' : ''"
          >
            <span class="frm-label" style="margin-left: 0.5em">
              <img src="@/assets/images/TDSDC/icon_search.png" />
            </span>
            <input
              type="search"
              class="frm-search-text"
              placeholder="検索キーワード"
              maxlength="255"
              ref="searchIndex"
              @change="setFilter"
              v-model.trim="searchKey"
            />
          </div>
        </div>
      </div>
      <div class="table-wrap" style="margin-top: 0px">
        <div class="frm-row">
          <div class="frm-item grow right">
            <p>{{ countStr }}</p>
          </div>
        </div>
        <div class="table-scroll-header">
          <table class="table-select single-select">
            <colgroup>
              <col style="width: 600px" />
              <!--機能-->
              <col style="width: auto" />
              <!--利用権限更新日時-->
              <col style="width: 220px" />
              <!--ボタン-->
            </colgroup>
            <thead>
              <tr>
                <th
                  class="sort hover alignleft"
                  @click="sortData('functionName')"
                >
                  機能
                  <div class="sort-toggle">
                    <button
                      class="sort-toggle-asc"
                      :class="
                        sort.key == 'functionName' && sort.isAsc ? 'on' : ''
                      "
                      type="button"
                    >
                      asc
                    </button>
                    <button
                      class="sort-toggle-desc"
                      :class="
                        sort.key == 'functionName' && !sort.isAsc ? 'on' : ''
                      "
                      type="button"
                    >
                      desc
                    </button>
                  </div>
                </th>
                <th
                  class="sort hover alignleft"
                  @click="sortData('updateDate')"
                >
                  利用権限更新日時
                  <div class="sort-toggle">
                    <button
                      class="sort-toggle-asc"
                      :class="
                        sort.key == 'updateDate' && sort.isAsc ? 'on' : ''
                      "
                      type="button"
                    >
                      asc
                    </button>
                    <button
                      class="sort-toggle-desc"
                      :class="
                        sort.key == 'updateDate' && !sort.isAsc ? 'on' : ''
                      "
                      type="button"
                    >
                      desc
                    </button>
                  </div>
                </th>
                <th></th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="table-scroll-body h-500px">
          <table class="table-select multi-select">
            <colgroup>
              <col style="width: 600px" />
              <!--機能-->
              <col style="width: auto" />
              <!--利用権限更新日時-->
              <col style="width: 220px" />
              <!--ボタン-->
            </colgroup>
            <tbody>
              <tr
                v-for="functionData in displayFunctionDataList"
                :key="functionData.id"
              >
                <td>{{ functionData.name }}</td>
                <td>{{ functionData.updateTimeFormat }}</td>
                <td align="center">
                  <button
                    class="frm-btn-operation ico ico-edit"
                    type="button"
                    @click="
                      handleEdit(
                        functionData.name,
                        functionData.functionAuthorityKeyName
                      )
                    "
                  >
                    編集
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="table-select single-select"
            style="background: #fff"
            v-show="displayFunctionDataList.length === 0"
          >
            <tbody>
              <tr>
                <p class="noData-area">
                  {{ noDataMsg }}
                </p>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//#region  インポート
import { useRouter } from "vue-router";
import { ref, computed, reactive, onMounted, nextTick, watch } from "vue";
import moment from "moment";
import Common from "@/util/common.js";
import { FUNCTION_AUTHORITY_LIST } from "@/util/data.js";
import HeaderNav from "@/components/AccountingHeader.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { createNamespacedHelpers, useStore } from "vuex";
import { API_DisplayFunctionUsageAuthorityList } from "@/api/Modules/DC05/STDSDC05C05";
import { API_SetFilter } from "@/api/Modules/CM04/STDSCM04C00.js";
//#endregion

//#region 変数定義
const pageId = ref("STDSDC05C05");
const functionDataList = ref([]);
const router = useRouter();
const store = useStore();
const searchKey = ref("");
const errorsList = ref([]);
const isLoading = ref(false);
const sortData = (key) => {
  Common.sortData2(sort, key);
};
const sort = reactive({
  key: "", // ソートキー
  isAsc: false, // 昇順ならtrue,降順ならfalse
});
const noDataMsg = ref(Common.getMessage("MTCL1118", ["機能利用権限"]));

//#region　計算
// 表示用データリスト
const displayFunctionDataList = computed(() => {
  let filterList = functionDataList.value.filter(
    (item) =>
      item.name.includes(searchKey.value) ||
      item.updateTimeFormat.includes(searchKey.value)
  );

  let sortedList = Common.listSort2(sort.key, sort.isAsc, filterList);

  return sortedList;
});

// 件数
const countStr = computed(() => {
  return searchKey.value
    ? `${displayFunctionDataList.value.length.toLocaleString()}/${functionDataList.value.length.toLocaleString()}件`
    : `${functionDataList.value.length.toLocaleString()}件`;
});

//エラーメッセージ
const errors = computed(() => {
  const subErrorList = store.getters["securityModule/getErrorStatus"]
    ? store.getters["securityModule/getErrors"]
    : [];
  return [...subErrorList, ...errorsList.value];
});
//#endregion

// フィルター条件保存処理
watch(searchKey, (newVal) => {
  const keyWordFilter = {
    searchKey: newVal,
    pageID: pageId.value,
    sessinID: $cookies.get("SessionID"),
  };

  let params = {
    keyWordFilter: keyWordFilter,
  };

  // フィルター条件保存処理
  API_SetFilter(params);
});

//一覧データを取得
const getList = () => {
  store.commit("businessModule/processDialogue", true);
  const functionAuthorityInfoLst = ref([]);
  FUNCTION_AUTHORITY_LIST.forEach((item) => {
    functionAuthorityInfoLst.value.push({
      name: item.name,
      serviceKeyName: item.serviceKeyName,
    });
  });

  return API_DisplayFunctionUsageAuthorityList(functionAuthorityInfoLst.value)
    .then((response) => {
      if (response.result == "0000") {
        functionDataList.value = response.functionAuthorityInfoLst;
        functionDataList.value.forEach((functionData) => {
          functionData.updateTimeFormat = functionData.updateDateTime
            ? moment(functionData.updateDateTime).format("YYYY/MM/DD HH:mm:ss")
            : "-";
        });
        // 保存されているフィルタ条件の適用
        if (
          response.keywordFilter &&
          response.keywordFilter.result === "0000"
        ) {
          searchKey.value = response.keywordFilter.searchKey;
        }
      } else {
        // エラー表示
        errors.value.push(
          Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [])
          )
        );
      }
    })
    .finally(() => {
      store.commit("businessModule/processDialogue", false);
    });
};

// 「編集」ボタン押下処理
const handleEdit = (name, functionName) => {
  $cookies.set("05C05_name", name, "0");
  $cookies.set("05C05_functionName", functionName, "0");
  router.push({ name: "STDSDC05C06" });
};

//画面初期化
const searchIndex = ref(null);
onMounted(() => {
  // 初期フォーカス設定(事業者コード)
  nextTick(() => searchIndex.value.focus());
  // エラーメッセージを初期化
  store.commit("securityModule/updateErrors", []);
  getList();
});
</script>
